import { ChevronsUpDown, LogOut as LogOutIcon, Sparkles, ArrowLeftRight } from "lucide-react";
import { Avatar, AvatarFallback } from "../../components/shadcn-ui//avatar";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../../components/shadcn-ui/dropdown-menu";
import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from "../../components/shadcn-ui/sidebar";
import { Link } from "react-router-dom";
import { useAuth } from "context/AuthContext";
import { switchExperience } from "../../shared/experience-toggle";

export function NavUser() {
  const { isMobile } = useSidebar();
  const { logout, userDetails } = useAuth();

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <SidebarMenuButton
              size="lg"
              className="data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground"
            >
              <Avatar className="h-8 w-8 rounded-lg">
                {/* TODO: update image of user when ready  */}
                {/* <AvatarImage src={user.avatar} alt={user.name} /> */}
                <AvatarFallback className="text-lg">
                  {userDetails?.userName?.charAt(0)?.toUpperCase() || 'U'}
                </AvatarFallback>
              </Avatar>
              <div className="grid flex-1 text-left text-sm leading-tight">
                <span className="truncate font-semibold">
                  {userDetails?.userName}
                </span>
                <span className="truncate text-xs">{userDetails?.role}</span>
              </div>
              <ChevronsUpDown className="ml-auto size-4" />
            </SidebarMenuButton>
          </DropdownMenuTrigger>
          <DropdownMenuContent
            className="w-[--radix-dropdown-menu-trigger-width] min-w-56 rounded-lg"
            side={isMobile ? "bottom" : "right"}
            align="end"
            sideOffset={4}
          >
            <DropdownMenuLabel className="p-0 font-normal">
              <div className="flex items-center gap-2 px-1 py-1.5 text-left text-sm">
                <Avatar className="h-8 w-8 rounded-lg">
                  {/* TODO: update image of user when ready  */}
                  {/* <AvatarImage src={user.avatar} alt={userDetails?.userName} /> */}
                  <AvatarFallback className="text-lg">
                    {userDetails?.userName?.charAt(0)?.toUpperCase() || 'U'}
                  </AvatarFallback>
                </Avatar>
                <div className="grid flex-1 text-left text-sm leading-tight">
                  <span className="truncate font-semibold">
                    {userDetails?.userName}
                  </span>
                </div>
              </div>
            </DropdownMenuLabel>
            <DropdownMenuSeparator />
            <DropdownMenuGroup>
              <Link to="/settings">
                <DropdownMenuItem>
                  <Sparkles />
                  Settings
                </DropdownMenuItem>
              </Link>
              <DropdownMenuItem onClick={() => switchExperience('v3')}>
                <ArrowLeftRight />
                Switch to New Experience
              </DropdownMenuItem>
            </DropdownMenuGroup>
            <DropdownMenuSeparator />
            <DropdownMenuItem onClick={() => logout()}>
              <LogOutIcon /> Log out
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </SidebarMenuItem>
    </SidebarMenu>
  );
}
